<ng-container *transloco="let t">
	<div class="prism-headline-xs">{{ t(navTitleTranslationKey()) }}</div>
	@if (hasSecondaryNavButton() && navButtonData()) {
		<prism-button
			id="sh-sec-nav-button"
			variant="bright"
			(click)="navButtonClick()"
			[disabled]="navButtonData()?.showProgressIndicator"
		>
			@if (navButtonData()!.showProgressIndicator) {
				<prism-progress-indicator
					type="circular"
					mode="indeterminate"
					value="0"
					size="sm"
					id="sh-sec-nav-loading-icon"
					slot="icon-start"
				></prism-progress-indicator>
			} @else {
				<prism-icon id="sh-sec-nav-plus-icon" slot="icon-start" [icon]="navButtonData()!.icon"></prism-icon>
			}
			{{ t(navButtonData()!.buttonText) }}
		</prism-button>
	}
	<prism-nav-group class="sh-secondary-nav-group">
		@for (navListItems of navItems(); track navListItems.id) {
			<prism-nav-button
				secondary
				[id]="'sh-app-shell-prism-sec-nav-button-' + navListItems.id"
				[routerLink]="[getDynamicRoutes(navListItems)]"
				[href]="[getDynamicRoutes(navListItems)]"
				(click)="handleNavButtonClick($event)"
				[selected]="activeListItem()?.key === navListItems.key"
			>
				@if (navListItems.icon) {
					<prism-icon
						[id]="'sh-app-shell-prism-sec-nav-icon-' + navListItems.id"
						slot="icon"
						[icon]="navListItems.icon"
					></prism-icon>
					{{ t(navListItems.listItem) }}
					@if (navListItems.listItemPostfix) {
						<span id="sh-app-shell-prism-sec-nav-postfix-{{ navListItems.id }}">
							{{ navListItems.listItemPostfix }}
						</span>
					}
				} @else {
					<span class="sh-secondary-nav-item-span" id="sh-app-shell-prism-sec-nav-span-{{ navListItems.id }}">
						{{ t(navListItems.listItem) }}
					</span>
				}
			</prism-nav-button>
		}
	</prism-nav-group>
</ng-container>
